export enum BUTTON_VARIANT {
  LINK = 'link',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  PRIMARY_HEADER = 'primaryHeader',
  CLOSE_BUTTON = 'closeButton',
  DANGER = 'danger',
}
